// OT batches (lote L-<n>) -- pure helpers, tested by loteLogica.test.mjs.

// Rows pasted from Excel (tab-separated; one item per line): code,
// description, quantity. A header line (no number in the third column) and
// empty lines are skipped; a decimal comma is read as a point.
export function filasDesdeTexto(texto) {
  const out = []
  for (const linea of String(texto || '').split(/\r?\n/)) {
    if (!linea.trim()) continue
    const [cod = '', desc = '', cant = ''] = linea.split('\t').map(x => x.trim())
    const n = cant === '' ? null : Number(cant.replace(',', '.'))
    if (cant !== '' && Number.isNaN(n)) {
      if (!out.length) continue                    // the header
      out.push({ articulo_codigo: cod, articulo_descripcion: desc, cantidad: null })
      continue
    }
    out.push({ articulo_codigo: cod, articulo_descripcion: desc, cantidad: n })
  }
  return out
}

// The admission tray's list: single OTs, and each batch's waiting OTs as one
// entry. -> [{ tipo: 'ot', ot } | { tipo: 'lote', lote: { id, codigo }, ots }],
// in the order the first of each arrives.
export function agruparPorLote(ots) {
  const out = [], lotes = new Map()
  for (const o of ots) {
    if (!o.lote) { out.push({ tipo: 'ot', ot: o }); continue }
    if (!lotes.has(o.lote.id)) {
      const e = { tipo: 'lote', lote: o.lote, ots: [] }
      lotes.set(o.lote.id, e)
      out.push(e)
    }
    lotes.get(o.lote.id).ots.push(o)
  }
  return out
}

// Rows that block sending the batch (the server checks again).
export const BLOQUEAN = ['falta_codigo', 'falta_cantidad', 'repetido']
